<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins [title]="'scenes.configuration.shared.online-receiver.dialog.title' | translate"
		id="online-receivers-dialog-header" (onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			@if (viewModel.isFormReady) {
				@if (!(viewModel.onlineReceivers.length > 0)) {
					<div>
						<div class="align--form">
							<span class="align--tiny-right" id="online-receiver-no-receivers-available-message">
								{{'scenes.configuration.shared.online-receiver.dialog.form.messages.no-available-receivers.info'
								| translate}}
							</span>
							<a class="link link--blue" [href]="viewModel.noAvailableReceiversUrl" target="_blank"
								id="online-receiver-no-receivers-available-redirect-link">
								{{'scenes.configuration.shared.online-receiver.dialog.form.messages.no-available-receivers.move-to'
								| translate}}
							</a>
						</div>
					</div>
				} @else {
					<div class="grid" [sklValidationSource]="viewValidation">
						<div class="col-1">
							<ins-form-field [skl-focus-by]
								[label]="'scenes.configuration.shared.online-receiver.dialog.form.name.label' | translate">
								<ins-select display-text="name" id="online-receivers-dialog-online-receiver"
									[(ngModel)]="viewModel.onlineReceiver"
									(ngModelChange)="viewModel.onOnlineReceiverChange()"
									[sklValidate]="getValidationKey('onlineReceiver')">
									@for (item of viewModel.onlineReceivers; track item) {
									<ins-option [value]="item">
										<span [ngClass]="[item.textStyle]"> {{ item.name }} </span>
									</ins-option>
									}
									<span slot="content" [ngClass]="[viewModel.onlineReceiver?.textStyle || '']">
										@if (viewModel.onlineReceiver) {
										<span>{{ viewModel.onlineReceiver.name }}</span>
										} @else {
										<span class="input-placeholder"> {{
											'scenes.configuration.shared.online-receiver.dialog.form.name.placeholder' |
											translate }}</span>
										}
									</span>
								</ins-select>
							</ins-form-field>
						</div>
						<div class="col-1">
							<ins-form-field
								[label]="'scenes.configuration.shared.online-receiver.dialog.form.password.label' | translate">
								<skl-password-ins [(ngModel)]="viewModel.password" id="online-receivers-dialog-password"
									(ngModelChange)="viewModel.onPasswordChange()"
									[validationKey]="getValidationKey('password')"
									[placeholder]="'scenes.configuration.shared.online-receiver.dialog.form.password.placeholder' | translate">
								</skl-password-ins>
							</ins-form-field>
						</div>
					</div>
				}
			}
		</skl-form-container>
	</ins-content>

	@if (viewModel.onlineReceivers.length <= 0) { <ins-footer class="dialog__buttons">
		<skl-button  id="online-receivers-dialog-cancel-button-no-receivers"
			(click)="onCancel()">
			{{ 'scenes.configuration.shared.online-receiver.dialog.buttons.close' | translate}}
		</skl-button>
		</ins-footer>
		} @else {
		<ins-footer class="dialog__buttons">
			<skl-button  id="online-receivers-dialog-cancel-button"
				(click)="onCancel()">
				{{ 'scenes.configuration.shared.base.dialog.buttons.cancel' | translate}}
			</skl-button>
			<skl-button typeName="accent" id="online-receivers-dialog-save-button"
				[spinner]="viewModel.isSaving" (click)="onConfirmAsync()">
				{{ 'scenes.configuration.shared.base.dialog.buttons.save' | translate}}
			</skl-button>
		</ins-footer>
		}

</skl-dialog-content-ins>